'use client';

import { c as _c } from "react/compiler-runtime";
import { useAnalyticsPageView } from '@cc-shopping/platform-analytics/AnalyticsPageView/Context';
import { useAnalytics } from '@cc-shopping/platform-analytics/hooks/useAnalytics';
import { env } from '@cc-shopping/platform-env';
import { datadogRum } from '@datadog/browser-rum';
import { InitCompass } from '@nerdwallet/compass/next-init-compass';
import type { PropsWithChildren, ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
export function CompassPageViewRegistration(t0) {
  const $ = _c(12);
  const {
    children
  } = t0;
  const {
    pageViewId,
    pageName,
    contentId,
    contentSource
  } = useAnalyticsPageView();
  const {
    deployableName,
    deployableVersion
  } = useAnalytics();
  let t1;
  if ($[0] !== contentId || $[1] !== contentSource || $[2] !== deployableName || $[3] !== deployableVersion || $[4] !== pageName || $[5] !== pageViewId) {
    t1 = () => <ErrorBoundary fallback={<div />} onError={_temp}><InitCompass pageViewId={pageViewId} deployableName={deployableName} deployableVersion={deployableVersion} writeKey={env.NEXT_PUBLIC_SEGMENT_WRITE_KEY} driverContentId={contentId} driverContentSource={contentSource} driverPageName={pageName} /></ErrorBoundary>;
    $[0] = contentId;
    $[1] = contentSource;
    $[2] = deployableName;
    $[3] = deployableVersion;
    $[4] = pageName;
    $[5] = pageViewId;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const renderInitCompass = t1;
  let t2;
  if ($[7] !== renderInitCompass) {
    t2 = renderInitCompass();
    $[7] = renderInitCompass;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== children || $[10] !== t2) {
    t3 = <>{children}{t2}</>;
    $[9] = children;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
function _temp(error) {
  datadogRum.addError(error, {
    message: "Error initializing Compass"
  });
}